import { useCallback, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "../lib/api";
import { Search, Users } from "lucide-react";

export default function Customers() {
  const [q, setQ] = useState("");
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  const load = useCallback((query) => {
    setLoading(true);
    api.get("/customers/search", { params: { q: query || undefined, limit: 50 } })
      .then((r) => setItems(r.data || []))
      .finally(() => setLoading(false));
  }, []);

  useEffect(() => { load(""); }, [load]);

  useEffect(() => {
    const t = setTimeout(() => load(q), 300);
    return () => clearTimeout(t);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [q]);

  return (
    <div className="space-y-6" data-testid="customers-page">
      <div>
        <h1 className="font-display text-3xl font-bold">Customers</h1>
        <p className="text-slate-600 mt-1">Everyone who has booked with your business, aggregated from your booking history.</p>
      </div>

      <div className="relative max-w-md">
        <Search className="w-4 h-4 absolute left-3 top-1/2 -translate-y-1/2 text-slate-400" />
        <input
          data-testid="customers-search"
          value={q} onChange={(e) => setQ(e.target.value)}
          placeholder="Search name, email, phone…"
          className="pl-9 pr-3 py-2 rounded-lg border border-slate-300 bg-white outline-none focus:border-[#2D6A4F] text-sm w-full"
        />
      </div>

      <div className="rounded-xl border border-slate-200 bg-white overflow-hidden">
        {loading && <div className="p-6 text-slate-500">Loading…</div>}
        {!loading && items.length === 0 && (
          <div className="p-10 text-center text-slate-500" data-testid="customers-empty">
            <Users className="w-8 h-8 mx-auto text-slate-400" />
            <p className="mt-2">No customers found.</p>
          </div>
        )}
        <ul className="divide-y divide-slate-100">
          {items.map((c) => (
            <li key={c.email} data-testid={`customers-row-${c.email}`}>
              <Link to={`/app/customers/${encodeURIComponent(c.email)}`} className="block p-4 hover:bg-slate-50">
                <div className="flex flex-wrap items-center justify-between gap-2">
                  <div>
                    <div className="font-medium text-slate-900">{c.name || c.email}</div>
                    <div className="text-xs text-slate-500">{c.email}{c.phone ? ` · ${c.phone}` : ""}</div>
                  </div>
                  <div className="text-xs text-slate-500 text-right">
                    {c.booking_count} booking{c.booking_count === 1 ? "" : "s"}
                    {c.last_rental_at && <div>Last: {new Date(c.last_rental_at).toLocaleDateString("en-PH", { month: "short", year: "numeric" })}</div>}
                  </div>
                </div>
              </Link>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
}
